import React from "react";
import { Redirect } from "react-router-dom";
import RouteGuard from "../components/RouteGuard";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AdminDashboard from "../admin/dashboard/index";







import ResetPassword from "pages/Authentication/ResetPassword";

import Users from "admin/users";

import agents from "admin/agents";
import  properties from "admin/properties";
import brokers from "admin/brokers";
import UserProperties from "admin/users/UserProperties";
import UserPropertyDetailPage from "admin/users/UserPropertyDetailPage";
import UserEnquiries from "admin/users/UserEnquiries";
import  AgentProperties from "admin/agents/AgentProperties";
import BrokersAgents from "admin/brokers/BrokerAgents";
import PropertyDetailsPage from "admin/properties/PropertyDetailPage";
import BrokerDetail from "admin/brokers/BrokerDetail";
import BrokerAgents from "admin/brokers/BrokerAgents";
import BrokerProperties from "admin/brokers/BrokerProperties";
import SubscriptionPackages from "admin/subscription-packages";
import PaymentFailures from "admin/payment-failures";
import PropertyFeatures from "admin/property-features";


const authProtectedRoutes = [
  // Admin Routes 
  { path: "/admin/dashboard", component: AdminDashboard },
  { path: "/admin/users", component: Users },
  { path: "/admin/users/:userId/properties", component: UserProperties },
  { path: "/admin/users/:userId/properties/:propertyId/details", component: UserPropertyDetailPage },
  { path: "/admin/users/:userId/enquiries", component: UserEnquiries },
  {path:"/admin/agents/:userId/properties",component:AgentProperties},
  {path:"/admin/brokers/:agentId/agents",component:BrokersAgents},
  { path: "/admin/agents", component: agents },
  {path: "/admin/property/:id/details", component:PropertyDetailsPage},
  {path:"/admin/brokers",component:brokers},
  {
  path: "/admin/brokers/:brokerId",
  component: BrokerDetail
},
{
  path: "/admin/brokers/:brokerId/agents",
  component: BrokerAgents
},
{
  path: "/admin/brokers/:brokerId/properties",
  component: BrokerProperties
},
 

 
 
  { path: "/admin/property", component: properties },
  { path: "/admin/subscription-packages", component: SubscriptionPackages },
  { path: "/admin/payment-failures", component: PaymentFailures },
  { path: "/admin/property-features", component: PropertyFeatures },

  
 

 
  
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/admin/dashboard" />,
  },
].map(route => ({
  ...route,
  component: props => (
    <RouteGuard
      component={route.component}
      path={route.path}
      {...props}
    />
  ),
}));

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password", component: ResetPassword },
  // { path: "/register", component: Register },
  // { path: "*", component: staking },
];

export { authProtectedRoutes, publicRoutes };
